import { useMemo } from 'react';

import { useEligibleServicesStore } from '../../EligibleServicesSection/EligibleServices/stores';
import { useStore as useAdditionalStore } from '../Additional/stores/useAdditional.store';
import { useStore as useCardOfferedStore } from '../CardOffered/stores/useCardOffered.store';
import usePlanNameStore from '../PlanName/stores/usePlanName.store';
import usePlanOrganizationPathStore from '../PlanName/stores/usePlanOrganizationPath.store';
import { useStore as usePlanYearStore } from '../PlanYear/stores/usePlanYear.store';

export default () => {
  const planNameStore = usePlanNameStore((state) => state.state);
  const planYearStore = usePlanYearStore((state) => state.state);
  const cardOfferedStore = useCardOfferedStore((state) => state.state);
  const additionalStore = useAdditionalStore((state) => state.state);
  const eligibleServicesStore = useEligibleServicesStore((state) => state.state);
  const organizationPathStore = usePlanOrganizationPathStore((state) => state.state);

  const state = useMemo(() => ({
    ...planNameStore,
    ...planYearStore,
    ...cardOfferedStore,
    ...additionalStore,
    ...eligibleServicesStore,
    ...organizationPathStore,
  }), [
    additionalStore,
    cardOfferedStore,
    planNameStore,
    planYearStore,
    eligibleServicesStore,
    organizationPathStore,
  ]);
  return state;
};
